import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './SharedPostDisplay.css';
import { SocialPost } from './SocialPost';

const SharedPostDisplay = ({ sharedFromId }) => {
  if (!sharedFromId) return null;

  return (
    <div className="spd-container">
      <div className="spd-header">
        <span className="spd-label">Post partagé :</span>
      </div>
      <div className="spd-content">
        <SocialPost postId={sharedFromId} minimum={true} />
      </div>
    </div>
  );
};

export default SharedPostDisplay;
export { SharedPostDisplay };